import { createRouter, createWebHashHistory } from "vue-router";
import routes from "./routes";
import { local } from "@/utils/storage.js";

const router = createRouter({
  history: createWebHashHistory(),
  routes,
});


router.beforeEach((to, from,next) => {
  const access_token = local.get("access_token");
  const testerLogin  = local.get("testerLogin");
  // 有token
  if (access_token || to.meta.noNeedToken) {
    if(to.name === "AiHome" && window.global_config.LoginType === 1){
      if(!testerLogin){
        router.replace("/AiVideo"); 
        return false; // 中断当前导航
      }
    }
    if(to.name === "AiHome" && window.global_config.LoginType === 2){
      if(!testerLogin){
        router.replace("/new_AiVideo"); 
        return false; // 中断当前导航
      }
    }
  } else {
    // 没有token，且目标路由不是登录页，则重定向到登录页
    if (to.name !== "login") {
      if(window.global_config.LoginType === 0){
        router.replace("/login"); 
      }
      if(window.global_config.LoginType === 1){
        router.replace("/AiVideo"); 
      }
      if(window.global_config.LoginType === 2){
        router.replace("/new_AiVideo");
      }
      return false; // 中断当前导航
    }
  }
  return next()
});

export default router;
